import { useEffect, useState } from 'react';
import { mastheadMeta, navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setWordIndex((prev) => (prev + 1) % mastheadMeta.hotWords.length);
    }, 3200);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <header
      id="top"
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-transparent bg-background-50'
      }`}
    >
      <div className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto flex h-9 w-full max-w-[1360px] items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-3 overflow-hidden">
            <span className="hidden text-xs text-foreground-600 sm:inline">{mastheadMeta.dateLabel}</span>
            <span className="hidden h-3 w-px bg-background-300 sm:inline-block" />
            <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-600">
              <i className="ri-fire-line text-primary-600" />
              热词
              <span key={wordIndex} className="rise-in font-medium text-primary-600">
                {mastheadMeta.hotWords[wordIndex]}
              </span>
            </span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-600">
            <span className="hidden md:inline">{mastheadMeta.issue}</span>
            <a href="#download" className="hidden items-center gap-1 whitespace-nowrap transition-colors hover:text-primary-600 md:inline-flex">
              <i className="ri-smartphone-line" />
              客户端下载
            </a>
            <button
              type="button"
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-2.5 py-1 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100"
            >
              <i className="ri-quill-pen-line" />
              我要投稿
            </button>
          </div>
        </div>
      </div>

      <div className="mx-auto flex w-full max-w-[1360px] items-center justify-between gap-4 px-4 py-3 md:px-6 md:py-4">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-newspaper-line text-2xl" />
          </span>
          <span className="flex flex-col">
            <h1 className="font-heading text-2xl font-black leading-none tracking-tight text-foreground-950 md:text-[28px]">
              黑料社区
            </h1>
            <span className="mt-0.5 hidden text-[11px] tracking-[0.3em] text-foreground-500 sm:block">
              热帖 · 爆料 · 精华 · 讨论
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 md:flex">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜索帖子 / 关键词"
              className="w-36 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400 lg:w-44"
            />
          </div>
          <a
            href="#download"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <i className="ri-download-2-line" />
            下载客户端
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto grid w-full max-w-[1360px] grid-cols-2 gap-2 px-4 py-4" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}